import { Text } from '@radix-ui/themes';

export default Text;
